import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import translations from '../../../languages/i18n';

import { varStyles } from '../../../styles/formElementsStyles';

function Single({ handleResult, options, sharedId, field, form: { errors } }) {
  const [showError, setShowError] = useState(errors[field.name] ? true : false); // ATENCIÓ: no canviar per errors[field.name] || false ja que dins showError hi ha d'haver un boolea i si field.name existex llavors errors[field.name] no és un boolea sinó un string
  const [value, setValue] = useState(field.value || '');

  const varStyle = varStyles();

  useEffect(() => {
    setShowError(errors[field.name] ? true : false); // ATENCIÓ: no canviar per errors[field.name] || false ja que dins showError hi ha d'haver un boolea i si field.name existex llavors errors[field.name] no és un boolea sinó un string
  }, [errors[field.name]]);

  const handleChange = (event) => {
    setShowError(false); // Necessari ja que [errors[field.name]] no canvia de valor fins que no es fa validate al formulari
    handleResult(event);
    setValue(event.target.value);
  };

  return (
    <Grid container direction='column' justify='flex-start' spacing={2}>
      <Grid item xs={6}>
      {translations[`_t01${sharedId}`] && <Typography variant='h6' component='div' className={varStyle.title}>{translations[`_t01${sharedId}`]}</Typography>}
      {translations[`_t02${sharedId}`] && <Typography variant='body1' component='div' className={varStyle.subTitle}>{translations[`_t02${sharedId}`]}</Typography>}
        <Typography variant='body1' component='div'>                          
          {translations[`_q${sharedId}`].split("\n").map((i, key) => {
            return <div key={key}>{i}</div>;
          })}           
          </Typography>
      </Grid>
      <Grid item xs={6}>
        <FormControl component='fieldset'>
          {/* <FormLabel component='legend'>{translations[`_${sharedId}`] || sharedId}</FormLabel> */} {/* Si la variable no està traduida, es mostra el shareId */}
          <RadioGroup
            row
            aria-label={sharedId}
            variant='outlined'
            id={sharedId}
            name={sharedId}
            value={value}
            onChange={handleChange}
          >
            {options.map((option) => (
              <FormControlLabel
                key={`${sharedId}_${option}`}
                value={option}
                control={<Radio />}
                label={translations[`_o${sharedId}_${option}`] || option} // Si la opció no està traduida, es mostra option
              />
            ))}
          </RadioGroup>
          {translations[`_f01${sharedId}`] && <Typography variant='body1' component='div' className={varStyle.footer}>{translations[`_f01${sharedId}`]}</Typography>}
          <FormHelperText error={showError}>{showError ? errors[field.name] : ''}</FormHelperText>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default Single;

// Indica i controla els props que se han de passar al component
Single.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  handleResult: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  sharedId: PropTypes.string.isRequired,
};
